<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/h4kZJ7/tc-custom/9781634862028.jpg?1723406882374" alt="This image is the cover for the book Shorts Box Set"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shorts Box Set
      </h1>
      <p class="bookDescription body article font2">
        <p>Fourteen sinful, seductive, and downright sexy stories, these tales are a titillating foray into short gay erotic romance that will excite your senses and set your pulse racing. Here you'll find some of J.M. Snyder's best-selling short stories in one box set!<br/><br/>From best friends discovering each other for the first time to seasoned lovers stealing a quick moment alone to rivals who come together in a clash of sex and desire, these stories will take you on a wild ride through intimate moments and lustful hook-ups between men.<br/><br/>Contains the stories: <i>A Little Something for Santa, Battle of the Bands, Best Friends, Devilish Good Time, Easily Addicted, Escape, Hooking Up, Joy Ride, Office Visit, One of Us, Pony Play, Poolside, The New Client</i> , and <i>Threesome</i> .</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J.M. Snyder
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?186a72b0